import { str } from "@lit/localize";
//#region src/generated/locales/en.ts
var templates = {
	"pd.wizard.button.back": `Back`,
	"pd.wizard.button.next": `Next`,
	"pd.wizard.button.send": `Submit`,
	"pd.wizard.close.aria": `Close wizard`,
	"pdWizard.close.popup.cancel": `Cancel`,
	"pdWizard.close.popup.noStorage.content": `The current entries will be irretrievably lost after closing.`,
	"pdWizard.close.popup.ok": `Close`,
	"pdWizard.close.popup.storage.content": `The current entries can be saved for later editing or discarded?`,
	"pdWizard.close.popup.title": `Cancel editing`,
	"pdWizard.reload.popup.cancel": `Discard`,
	"pdWizard.reload.popup.lastModified": `Last modified:`,
	"pdWizard.reload.popup.ok": `Continue`,
	"pdWizard.reload.popup.title": `Continue editing?`,
	"pdWizard.reload.popup.warning": `Starting fresh will delete saved data`,
	"pdWizard.storage.close.popup.cancel": `Discard`,
	"pdWizard.storage.close.popup.ok": `Save`,
	"pd.steps.aria.label": `Wizard-Schritte`,
	"pd.steps.aria.passed": str`Schritt ${0}: ${1} - abgeschlossen, klicken um zurückzukehren`,
	"pd.steps.aria.current": str`Schritt ${0}: ${1} - aktueller Schritt`,
	"pd.steps.aria.pending": str`Schritt ${0}: ${1} - ausstehend`,
	"pd.wizard.button.cancel": `Abbrechen`
};
//#endregion
export { templates };
